export const REQUESTS_URL = "api/v3/document-requests";
export const REQUESTS_URL_V2 = "api/v3/document-requests";
export const REQUEST_URL = "api/requests/";
export const ASK_QUESTION_URL = "api/request/:requestId/:documentId/question";
export const NOT_REQUIRED_URL = "api/request/:requestId/:documentId/not-required";
